module.exports = __webpack_public_path__ + "static/media/onboarding-end-background.d1cbfecf.svg";